import type { EdgeInsets } from './types';

export function useSafeAreaInsets(): EdgeInsets {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
}
